module.exports = __webpack_public_path__ + "assets/3e0170d5a986af1cac6097b3d7b75fc8.mp4";